"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMaxStructureSteps = exports.maxStructureSteps = exports.setMaxStepStackDepth = exports.maxStepStackDepth = void 0;
const DefaultMaxStepStackDepth = 50;
const MaxStructureStepsDefault = 9999; // not sure what value to give this.. early apps far fewer so far, will see
let _maxStepStackDepthOverride;
let _maxStructureStepsOverride;
/**
 * Max depth of automations starting other automations.
 * note: implementation is currently (feb 2021) crude/primitive. See notes in start-automation-runtime-service.ts.
 */
function maxStepStackDepth() {
    return _maxStepStackDepthOverride || DefaultMaxStepStackDepth;
}
exports.maxStepStackDepth = maxStepStackDepth;
function setMaxStepStackDepth(val) {
    _maxStepStackDepthOverride = val;
}
exports.setMaxStepStackDepth = setMaxStepStackDepth;
/**
 * Max structure elements used in a build, including workflow steps, tasks, and behavior/function elements
 */
function maxStructureSteps() {
    return _maxStructureStepsOverride || MaxStructureStepsDefault;
}
exports.maxStructureSteps = maxStructureSteps;
function setMaxStructureSteps(val) {
    _maxStructureStepsOverride = val;
}
exports.setMaxStructureSteps = setMaxStructureSteps;
//# sourceMappingURL=step-stack-depth.js.map